export const state = {
  409: false,
}

export const mutations = {
  SET_FOUR_ZERO_NINE(state, newValue) {
    state[409] = newValue
  },
}

export const getters = {
  getErrors(state){
    return state
  },
}

export const actions = {
  setFourZeroNine({ commit }, value = false) {
    commit('SET_FOUR_ZERO_NINE', value)
  },
}
